import { render } from "./Replenish.vue?vue&type=template&id=6272beda"
import script from "./Replenish.vue?vue&type=script&lang=js"
export * from "./Replenish.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__